/**
 * @param {string|undefined|null} value
 * @returns {string}
 */
export const normalizeForComparison = (value) => (value || "").trim().toLowerCase();

/**
 * @param {string|undefined|null} left
 * @param {string|undefined|null} right
 * @returns {boolean}
 */
export const valuesMatch = (left, right) => normalizeForComparison(left) === normalizeForComparison(right);
